var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',_vm._b({ref:"select",staticClass:"admin-select",on:{"change":_vm.handleChange}},'select',_vm.$attrs,false),[_vm._t("default",function(){return _vm._l((_vm.options),function(option){return _c('option',{key:String(option.value),domProps:{"value":option.value}},[_vm._v("\n            "+_vm._s(option.label)+"\n        ")])})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }